// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    keys: {
      hi: 'Olá',
      all: 'Todos',
      logout: 'Sair do sistema',
      signin: 'Entrar',
      continue: 'Continuar',
      recovery_password: 'Recuperar senha',
      back: 'Voltar',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      no_entries: 'Nenhum registro encontrado.',
      filters: 'Filtros',
      filter: 'Consultar',
      data: 'Dados',
      columns: 'Colunas',
      saving: 'Salvando...',
      loading: 'Carregando...',
      downloading: 'Baixando...',
      waiting: 'Aguarde...',
      today: 'hoje',
      month: 'mês',
      week: 'semana',
      day: 'dia',
      list: 'lista',
      previous: 'anterior',
      next: 'próximo',
      details: 'Detalhes',
      warnings: 'Avisos',
      description: 'Descrição',
      unknown: 'Desconhecido(a)',
      free_price: 'Gratuito',
      paid_price: 'Pago',
      rerun: 'Executar novamente',
    },
    layout: {
      nav: {
        bots: { title: 'Meus Robôs' },
        marketplace: { title: 'Marketplace' },
        reports: { title: 'Relatórios' },
        databases: { title: 'Databases' },
        ocr: { title: 'OCR' },
        templates: { title: 'Templates' },
        admin: { title: 'Admin' },
        help: { title: 'Ajuda' },
      },
    },

    columns: {
      name: 'Nome',
      agenda_id: 'ID do grupo',
      email: 'E-mail',
      confirmation_code: 'Código de confirmação',
      lang: 'Idioma',
      password: 'Senha',
      attempts: 'Tentativas',
      created_at: 'Criado em',
      created_by: 'Criado por',
      updated_at: 'Atualizado em',
      status: 'Status',
      started_at: 'Iniciado em',
      start_at: 'Inicia em',
      title: 'Título',
      failed_reason: 'Motivo da falha',
      done_at: 'Concluído em',
      reason: 'Motivo',
      type: 'Tipo',
      description: 'Descrição',
      template: 'Template',
      device: 'Dispositivo',
    },

    messages: {
      invalid_password: 'Senha atual inválida. Por favor, tente novamente.',
      invalid_user_password: 'Usuário e/ou senha inválidos.',
      invalid_user: 'Usuário inválido. Por favor, tente novamente.',
      invalid_code: 'Código inválido. Por favor, tente novamente.',
      unexpected_error: 'Ocorreu um erro inesperado. Tente novamente.',
    },

    dialogs: {
      default: {
        title: 'Atenção!',
        description: 'Tem certeza que deseja continuar?',
      },
      buttons: {
        cancel: 'Não, cancela',
        confirm: 'Sim, continua',
      },
      remove: {
        title: 'Atenção!',
        description: 'Deseja realmente remover esse registro?',
      },
    },

    formats: {
      date: 'DD/MM/YYYY',
      datetime: 'DD/MM/YYYY HH:mm',
    },

    actions: {
      clean_all: 'Limpar todos os dados',
      save: 'Salvar',
      run: 'Executar',
      stop: 'Parar',
      cancel: 'Cancelar',
      remove: 'Remover',
      make_admin: 'Tornar Admin',
      remove_admin: 'Remover Admin',
      remove_entry: 'Remover registro',
      remove_entry_group: 'Remover todos os registros desse grupo',
      delete: 'Remover',
      search: 'Pesquisar',
      import: 'Importar',
      add: 'Adicionar',
      create: 'Criar',
      edit: 'Editar',
      invite: 'Convidar',
      resend: 'Reenviar',
      change: 'Alterar',
      change_password: 'Alterar senha',
      remove_all: 'Remover todos',
      add_rule: 'Adicionar regra',
      export_csv: 'Exportar para CSV',
      hire: 'Contratar',
      requesting: 'Solicitando',
    },

    status: {
      pending: 'Pendente',
      working: 'Executando',
      failed: 'Falhou',
      canceled: 'Cancelado',
      done: 'Concluído',
      not_done: 'Não concluído',
      processing: 'Processando',
      open: 'Aberto',
      in_progress: 'Em andamento',
    },

    signin: {
      description: 'Entre com suas credenciais.',
      code_sent: 'Enviamos um código de confirmação para seu email.',

      form: {
        email_input: {
          placeholder: 'Informe seu e-mail',
        },
        password_input: {
          placeholder: 'Informe sua senha',
        },
        code_input: {
          placeholder: 'Informe o código de confirmação',
        },
      },
    },

    forget_password: {
      title: 'Esqueceu sua senha?',
      description: 'Recupere sua conta! Informe seu e-mail e nós te enviaremos um link para que você possa recuperar sua senha.',
    },

    profile: {
      title: 'Perfil',
      dialogs: {
        remove_avatar: {
          description: 'Deseja realmente remover o seu avatar?',
        },
      },

      messages: {
        success_avatar_removed: 'Imagem removida com sucesso!',
        success_avatar_changed: `Imagem alterada com sucesso!`,
      },

      about_form: {
        title: 'Sobre você',
        name_input: {
          label: 'Nome:',
          placeholder: 'Informe o seu nome',
        },
        email_input: {
          label: 'E-mail:',
          placeholder: 'Informe o seu e-mail',
        },
        lang_input: {
          label: 'Idioma:',
          placeholder: 'Informe o seu idioma',
        },
      },

      security_form: {
        title: 'Segurança',
        password_input: {
          label: 'Senha atual:',
          placeholder: 'Informe sua senha atual',
        },
        new_password_input: {
          label: 'Nova senha:',
          placeholder: 'Informe sua nova senha',
        },
      },
    },

    authorizer: {
      no_permission: 'Você não possui permissão para acessar essa página.',
    },

    explore: {
      title: 'Marketplace',
      no_entries: 'Não encontrou o que queria?',
      categories: {
        title: 'Categorias',
      },
      actions: {
        request_custom: 'Solicitar robô customizado',
      },
      add: {
        title: 'Contratar Robô',
        free: 'Este robô é gratuito e não requer solicitação para sua contratação.',
        paid: 'Este robô requer solicitação para sua contratação. Caso tenha interesse, entre em contato conosco através do botão abaixo:',
        button_add_free: 'Contratar',
        button_add_free_hired: 'Contratado!',
        button_add_paid: 'Solicitar',
        button_add_paid_hired: 'Solicitado!',
      },
      price: {
        free: 'Grátis',
        paid: 'Disponível mediante solicitação',
      },
      install: {
        title: 'Como instalar e executar?',
        text: '<p>Para instalar nossos robôs é necessário a instalação da aplicação Youfy Agent no seu computador. Faça o download do app utilizando um dos links abaixos de acordo com o sistema operacional do computador onde deseja instalar e siga o passo a passo do instalador.</p><p>Após a instalação, abra a aplicação e faça o login utilizando as suas credenciais. Todos os robôs contratados serão exibidos. Faça o download dos robôs desejados clicando no botão de download e depois ative o mesmo clicando no botão de ativar.</p><p>Pronto! Depois da ativação o robô está pronto para receber os trabalhos através da nossa aplicação web. Na página "Meus bots", selecione o robô deseja e clique executar.</p>',
      },
    },

    bots: {
      title: 'Meus Robôs',
      bots_found: 'robôs disponíveis',
      no_entries: 'Seus robôs irão aparecer aqui. Mas, sua empresa ainda não possui nenhum robô. Aproveite e explore nossos robôs no Marketplace',
      no_config: 'Este robô não possui configurações.',
      tabs: {
        jobs: 'Trabalhos',
        config: 'Configurações',
        calendar: 'Calendário',
        reports: 'Relatórios',
      },
      categories: {
        title: 'Setores',
        none: 'Sem setor',
      },
      config: {
        about: {
          title: 'DADOS',
        },
        notification: {
          title: 'NOTIFICAÇÕES',
          form: {
            events: 'Eventos',
          },
        },
        task: {
          title: 'TAREFA',
          no_form_message: 'Para este robô, não é necessário preencher nenhuma configuração.',
        },
      },
      reports: {
        add: {
          title: 'Novo relatório',
          form: {
            name: {
              label: 'Nome do relatório',
            },
            description: {
              label: 'Descrição',
            },
          },
        },
      },
      jobs: {
        disabled: 'Este bot está desabilitado',
        details: {
          title: 'Detalhes do trabalho',
        },
        messages: {
          waiting_device: 'Aguardando resposta do dispositivo...',
        },
        add: {
          title: 'Executar trabalho',
          no_form_message: 'Para este bot, não é necessário preencher nenhum parâmetro.',
          error_add: 'Falha ao tentar criar trabalho. Por favor, tente novamente.',
        },
        card: {
          pending: 'Na fila',
          done: 'Concluídos',
          not_done: 'Não concluídos',
          failed: 'Falharam',
          total: 'Total',
          working: 'Em execução',
          avg_time: 'Tempo médio',
          job_time: 'Tempo total',
          columns: {
            request_by: 'Solicitado por',
            created_at: 'Solicitado em',
            started_at: 'Iniciado em',
            done_at: 'Concluído em',
          },
        },
        sections: {
          working: {
            title: 'EM EXECUÇÃO',
          },
          last_jobs: {
            title: 'ÚLTIMOS TRABALHOS',
          },
        },
      },
    },

    agenda: {
      actions: {
        repeat: 'Repetir',
      },
      dialogs: {
        remove_item: {
          title: 'Remover item',
          description: `Deseja realmente remover o item <b>{{title}}</b> em {{ date }}?`,
        },

        remove_all: {
          title: 'Remover todos itens',
          description: `Deseja realmente remover <b class="text-danger">todos</b> os itens?`,
        },
      },
      form: {
        title: {
          label: 'Título de identificação',
        },
        date: {
          label: 'Data',
        },
        time: {
          label: 'Hora',
        },
      },
    },

    devices: {
      form: {
        title: {
          label: 'Dispositivo',
        },
      },
    },

    work_objects: {
      title: 'Objetos de trabalho',
    },

    databases: {
      title: 'Databases',
    },

    ocr: {
      title: 'OCR',
      add: {
        title: 'Adicionar Template OCR',
      },
    },

    templates: {
      title: 'Templates',
      helps: {
        name: 'O nome é um id único sem caracteres especiais para identificar o template.',
      },
    },

    reports: {
      title: 'Relatórios',
      require_filter: 'Por favor, preencha os filtros do relatório para visualizar os dados.',
    },

    database: {
      not_found: 'Ops! Não consegui encontrar os dados que você procura.',
      actions: {
        import_data: 'Importar dados',
      },
      alerts: {
        remove: {
          title: 'Calma!',
          text: 'Você realmente deseja remover este item?',
        },
        remove_all: {
          title: 'Calma!',
          text: 'Você realmente deseja remover todos os items deste database?',
        },
      },
    },

    importer: {
      title: 'Importação de dados',
      actions: {
        download_template: 'Baixe aqui o template de importação',
      },
    },

    exporter: {
      title: 'Exportação de dados',
      actions: {
        download_csv: 'Download CSV',
        show_downloads: 'Ver dados exportados',
      },
      types: {
        work_objects: 'Objetos de trabalho',
        bot_reports: 'Relatórios dos bots',
        databases: 'Databases',
      },
    },

    admin: {
      members: {
        tab: 'Membros',
      },

      roles: {
        tab: 'Pápeis',
        columns: {
          name: 'Nome',
        },
        form: {
          name_input: {
            label: 'Nome:',
            placeholder: 'Informe o nome do papel',
          },

          sections: {
            permissions: {
              title: 'Permissões',
            },
          },
        },
      },

      invites: {
        tab: 'Convites',
        title: 'Convidar Membro',
        messages: {
          invite_sent: 'Convite enviado',
          invite_conflit: 'Já existe um convite para esse e-mail',
        },
        columns: {
          invited_by: 'Convidado por',
          date: 'Data',
        },
        form: {
          email_input: {
            label: 'Informe o e-mail do novo membro:',
          },
          role_input: {
            label: 'Informe o papel do novo membro:',
          },
        },
      },

      categories: {
        tab: 'Setores',
        columns: {
          name: 'Name',
        },
        errors: {
          remove: 'Não foi possível remover esse setor. Certifique-se que não há nenhum bot associado ao mesmo.',
        },
        form: {
          name_input: {
            placeholder: 'Informe o nome do setor',
          },
        },
      },
    },

    components: {
      users: {
        role_select: {
          placeholder: 'Adicione pápeis',
        },
        actions: {
          remove: 'Remover membro',
          make_admin: 'Tornar administrador',
          remove_admin: 'Remover administrador',
        },
        confirmations: {
          remove: `Deseja realmente remover o membro <b>{{name}}</b> do time?`,
          make_admin: 'Deseja realmente tornar o membro <b>{{name}}</b> administrador da empresa?',
          remove_admin: 'Deseja realmente remover o membro <b>{{name}}</b> dos administradores da empresa?',
        },
      },
    },

    react_query_builder: {
      larger: 'Maior que',
      smaller: 'Menor que',
      larger_equal: 'Maior igual que',
      smaller_equal: 'Menor igual que',
      equal: 'Igual',
      not_equal: 'Diferente',
      not_in: 'Diferente em',
      between: 'Entre',
      not_between: 'Não se encontra entre',
      like: 'Contém',
      not_like: 'Não contém',
      select_value: 'Selecione o valor',
    },

    pagination: {
      items_per_page: 'Quantidade de itens por página',
    },
  },
};
